import { fromJS /*,Set*/ } from "immutable";
import {
  SEGMENTS_ATTR,
  SELECT_SEGMENT,
  ALLSTATES,
  SET_SEGMENT_NAME,
  SELECTED_CITY,
  SELECTED_COUNTY,
  SELECTED_DMA,
  GET_CITY,
  SELECTED_STATE,
  SET_PLOT_VALUES,
  CLEAR_STATES,
  CLEAR_CITYS,
  CLEAR_COUNTY,
  CLEAR_DMA,
  ADD_ZIPCODE,
  CLEAR_ALL_ZIPCODE,
  CLEAR_ZIPCODE,
  SELECTED_MAKE,
  SELECTED_MODEL,
  SELECTED_CC_REGION,
  SELECTED_CC_LOCALE,
  VERIFY_SEGMENT_NAME,
  GET_ALL_STATE_CITIES,
  GET_COUNTY,
  LOADING,
  ADD_MAKE_ACTIVE,
  ADD_REGION_ACTIVE,
  SAVE_SEGMENT,
  GET_AUDIENCE_COUNT,
  CLEAR_AUDIENCE_COUNT,
  GET_PLOTTED_AUDIENCE_COUNT,
  GET_ZIPCODE_AUDIENCE_COUNT,
  GET_ZIPCODE_DETAIL_COUNTS,
  CATEGORY_AUDIENCE_COUNTS,
  CLEAR_CATEGORY_AUDIENCE_COUNTS,
  CHECK_SEGMENT_LIMIT,
  SET_TARGET_HOUSEHOLD_ONLY,
  GET_DMAS,
  SELECTED_ALL_STATE,
  CLEAR_ALL_AUTO,
  CLEAR_ALL_REGION,
} from "../actions/SegmentCreation";
import { SEND_ASSIST_REQUEST } from "../actions/Insights";
import {
  SEGMENT_SUMMARY,
  CLEAR_SEGMENT_SUMMARY,
  SEGMENT_COUNTS,
  SEGMENT_ATTR_COUNTS,
  CLEAR_SEGMENT_ATTR_COUNTS,
  REQUEST_ACTIVATION,
} from "../actions/SegmentDetail";
import { success, failure, request, invalid } from "./helpers";
import { remove, map, tail } from "lodash";
import sortedUniq from "lodash/sortedUniq";

const initialState = {
  selected_segments: [],
  selected_city: [],
  selected_county: [],
  selected_dma: [],
  selected_state: [],
  zipcode: [],
  selected_make: [],
  selected_model: [],
  selected_culture_region: [],
  selected_culture_locale: [],
  copy_segment_name: "",
  segment_id: "",
  rules_id: [],
  all_state_cities: [],
  ifLoading: false,
  value_typehead: [{ id: "", label: "", parent: "" }],
  make_active_arr: [],
  region_active_arr: [],
  save_segment_report_id: "",
  segment_counts: 0,
  audience_total_count: 0,
  plotted_values: null,
  allstates: [],
  save_segment_success: undefined,
  save_segment_error_message: undefined,
  send_assist_request_error: undefined,
  request_assist_successful: undefined,
  check_client_limit: undefined,
  targetHouseholdsOnly: undefined,
};

export const segmentCreation = (state = initialState, action) => {
  let catAudienceCounts = {};
  switch (action.type) {
    case SEGMENTS_ATTR:
    case success(SEGMENTS_ATTR):
      state = fromJS(state);
      const categories = action.payload;
      const value_typehead = [];
      const demographic = categories ? tail(categories) : undefined;
      if (demographic) {
        map(demographic, (cat) => {
          map(cat.attributes, (attr) => {
            value_typehead.push({
              id: attr.id,
              label: attr.name,
              parent: cat.name,
            });
            map(attr.values, (val) => {
              const obj = { id: 0, label: "", parent: "" };
              obj.id = val.id;
              obj.label = val.label;
              obj.parent = attr.name;
              value_typehead.push(obj);
            });
            map(attr.subAttributes, (subAttr) => {
              const obj = { id: 0, label: "", parent: "" };
              obj.id = subAttr.id;
              obj.label = subAttr.name;
              obj.parent = attr.name;
              value_typehead.push(obj);
              map(subAttr.values, (val) => {
                const obj = { id: 0, label: "", parent: "" };
                obj.id = val.id;
                obj.label = val.label;
                obj.parent = subAttr.name;
                value_typehead.push(obj);
              });
            });
          });
        });
      }
      return state
        .set("categories", categories)
        .set("value_typehead", value_typehead)
        .toJS();
    case SELECT_SEGMENT:
      let segments = state["selected_segments"] || [];
      if (action.value instanceof Array) {
        segments = action.value.slice();
      } else {
        if (segments.indexOf(action.value) >= 0) {
          remove(segments, (n) => {
            return n === action.value;
          });
        } else {
          segments.push(action.value);
        }
      }
      state = fromJS(state);
      return state.set("selected_segments", segments).toJS();
    case success(ALLSTATES):
      return Object.assign({}, state, { allstates: action.payload });
    case success(GET_CITY):
      return {
        ...state,
        allcities: action.payload,
      };
    case SELECTED_CITY:
      let city = state["selected_city"] || [];
      if (action.flag) {
        action.value["state"] = action.stateLabel;
        city.push(action.value);
      } else if (!action.flag) {
        remove(city, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_city: sortedUniq(city),
      };
    case SELECTED_COUNTY:
      let county = state["selected_county"] || [];
      if (action.flag) {
        //action.value["state"] = action.stateLabel;
        county.push(action.value);
      } else if (!action.flag) {
        remove(county, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_county: sortedUniq(county),
      };
    case SELECTED_DMA:
      let dma = state["selected_dma"] || [];
      if (action.flag) {
        //action.value["state"] = action.stateLabel;
        dma.push(action.value);
      } else if (!action.flag) {
        remove(dma, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_dma: sortedUniq(dma),
      };
    case CLEAR_CITYS:
      return {
        ...state,
        selected_city: [],
        zipcode_audience_count: null,
      };
    case CLEAR_COUNTY:
      return {
        ...state,
        selected_county: [],
      };
    case CLEAR_DMA:
      return {
        ...state,
        selected_dma: [],
      };
    case SELECTED_STATE:
      let sta = state["selected_state"] || [];
      if (action.flag) {
        sta.push(action.value);
      } else if (!action.flag) {
        remove(sta, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_state: sortedUniq(sta),
      };
    case SELECTED_ALL_STATE:
      sta = state["selected_state"] || [];
      if (action.flag) {
        sta = action.value;
      } else if (!action.flag) {
        sta = [];
      }
      return {
        ...state,
        selected_state: sortedUniq(sta),
        selected_city: [],
      };
    case CLEAR_STATES:
      return {
        ...state,
        selected_state: [],
        zipcode_audience_count: null,
      };
    case ADD_ZIPCODE:
      let zipcode = state["zipcode"] ? state["zipcode"] : [];
      let splitZipCode = action.value.split(",");

      map(splitZipCode, (zip) => {
        const item = {
          zipcode: zip,
        };
        zipcode.push({
          zipcode: item.zipcode,
        });
      });

      return {
        ...state,
        zipcode: zipcode,
      };
    case SET_PLOT_VALUES:
      state = fromJS(state);
      return state.set("plotted_values", action.value).toJS();
    case CLEAR_ALL_ZIPCODE:
      return {
        ...state,
        zipcode: [],
        zipcode_audience_count: null,
      };
    case CLEAR_ZIPCODE:
      let zipco = state["zipcode"];
      remove(zipco, (val) => val.zipcode === action.value);
      return {
        ...state,
        zipcode: zipco,
      };
    case SET_SEGMENT_NAME:
      state = fromJS(state);
      return state
        .remove("isNameDuplicated")
        .set("segment_name", action.value)
        .toJS();

    case SELECTED_MAKE:
      let make = state["selected_make"];
      if (action.flag) {
        make.push(action.value);
      } else if (!action.flag) {
        remove(make, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_make: sortedUniq(make),
      };
    case CLEAR_ALL_AUTO:
      return {
        ...state,
        selected_model: [],
        selected_make: [],
      };
    case SELECTED_MODEL:
      let model = state["selected_model"];
      if (action.flag) {
        model.push(action.value);
      } else if (!action.flag) {
        remove(model, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_model: sortedUniq(model),
      };
    case SELECTED_CC_REGION:
      let region = state["selected_culture_region"];
      if (action.flag) {
        region.push(action.value);
      } else if (!action.flag) {
        remove(region, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_culture_region: sortedUniq(region),
      };
    case SELECTED_CC_LOCALE:
      let locale = state["selected_culture_locale"];
      if (action.flag) {
        locale.push(action.value);
      } else if (!action.flag) {
        remove(locale, (n) => {
          return n.id === action.value.id;
        });
      }
      return {
        ...state,
        selected_culture_locale: sortedUniq(locale),
      };
    case CLEAR_ALL_REGION:
      return {
        ...state,
        selected_culture_region: [],
        selected_culture_locale: [],
      };
    case success(VERIFY_SEGMENT_NAME):
      state = fromJS(state);
      return state.set("isNameDuplicated", false).toJS();
    case failure(VERIFY_SEGMENT_NAME):
      state = fromJS(state);
      return state.set("isNameDuplicated", true).toJS();
    case success(GET_ALL_STATE_CITIES):
      return {
        ...state,
        all_state_cities: action.payload,
      };
    case success(GET_COUNTY):
      return {
        ...state,
        counties: action.payload,
      };
    case success(GET_DMAS):
      return {
        ...state,
        dmas: action.payload,
      };
    case LOADING:
      return {
        ...state,
        ifLoading: action.value,
      };
    case ADD_MAKE_ACTIVE:
      return {
        ...state,
        make_active_arr: action.value,
      };
    case ADD_REGION_ACTIVE:
      return {
        ...state,
        region_active_arr: action.value,
      };
    case request(CHECK_SEGMENT_LIMIT):
      return {
        ...state,
        save_segment_success: undefined,
        check_client_limit: undefined,
        save_segment_error_message: undefined,
        save_segment_error_errorNo: undefined,
      };
    case success(CHECK_SEGMENT_LIMIT):
      return {
        ...state,
        save_segment_success: true,
        check_client_limit: true,
        save_segment_error_message: undefined,
        save_segment_error_errorNo: undefined,
      };
    case failure(CHECK_SEGMENT_LIMIT):
    case invalid(CHECK_SEGMENT_LIMIT):
      return {
        ...state,
        save_segment_success: false,
        check_client_limit: false,
        save_segment_error_message: action.payload.message,
        save_segment_error_errorNo: action.payload.errorNo,
      };
    case request(SAVE_SEGMENT):
      return {
        ...initialState,
        save_segment_success: undefined,
        save_segment_error_message: undefined,
        save_segment_error_errorNo: undefined,
      };
    case success(SAVE_SEGMENT):
      return {
        ...initialState,
        save_segment_success: true,
        save_segment_error_message: undefined,
        save_segment_error_errorNo: undefined,
        save_segment_report_id: action.payload.segment.id,
      };
    case failure(SAVE_SEGMENT):
    case invalid(SAVE_SEGMENT):
      return {
        ...initialState,
        save_segment_success: false,
        save_segment_error_message: action.payload.message,
        save_segment_error_errorNo: action.payload.errorNo,
        save_segment_report_id: undefined,
      };
    case request(SEND_ASSIST_REQUEST):
      return {
        ...state,
        send_assist_request_error: undefined,
        request_assist_successful: undefined,
      };
    case success(SEND_ASSIST_REQUEST):
      return {
        ...state,
        send_assist_request_error: undefined,
        request_assist_successful: true,
      };
    case invalid(SEND_ASSIST_REQUEST):
    case failure(SEND_ASSIST_REQUEST):
      return {
        ...state,
        send_assist_request_error:
          "Message send failure. Please try again later...",
        request_assist_successful: false,
      };
    case success(GET_AUDIENCE_COUNT):
      return {
        ...state,
        audience_total_count: action.payload,
      };
    case CLEAR_AUDIENCE_COUNT:
      state = fromJS(state);
      return state.remove("audience_total_count").toJS();
    case success(GET_PLOTTED_AUDIENCE_COUNT):
      const obj = state["plotted_values"];
      obj.audienceCount.total = action.payload.total;
      obj.audienceCount.email = action.payload.email;
      obj.audienceCount.display = action.payload.display;
      obj.audienceCount.social = action.payload.social;
      return {
        ...state,
        plotted_values: obj,
      };
    case success(GET_ZIPCODE_AUDIENCE_COUNT):
      return {
        ...state,
        zipcode_audience_count: {
          total: action.payload.total,
          email: action.payload.email,
          display: action.payload.display,
          social: action.payload.social,
        },
      };
    case success(GET_ZIPCODE_DETAIL_COUNTS):
      const zipcodes = state["zipcode"] ? state["zipcode"] : [];
      const zipcodes_with_counts = [];
      map(zipcodes, (zip) => {
        const counts = action.payload[zip.zipcode];
        zipcodes_with_counts.push({
          zipcode: zip.zipcode,
          total: counts.total,
          email: counts.email,
          social: counts.social,
          display: counts.display,
        });
      });
      return {
        ...state,
        zipcode: zipcodes_with_counts,
      };
    case success(CATEGORY_AUDIENCE_COUNTS):
      catAudienceCounts =
        state["catAudienceCounts"] === undefined
          ? {}
          : state["catAudienceCounts"];

      catAudienceCounts[action.payload.categoryId] = action.payload.total;
      return {
        ...state,
        catAudienceCounts: catAudienceCounts,
      };
    case CLEAR_CATEGORY_AUDIENCE_COUNTS:
      state = fromJS(state);
      catAudienceCounts = state["catAudienceCounts"];
      if (catAudienceCounts) {
        delete catAudienceCounts[action.value];
      }
      return state.set("catAudienceCounts", catAudienceCounts).toJS();
    case SET_TARGET_HOUSEHOLD_ONLY:
      return {
        ...state,
        targetHouseholdsOnly: Boolean(action.value),
      };
    default:
      return state;
  }
};

export const segmentDetail = (state = {}, action) => {
  state = fromJS(state);
  switch (action.type) {
    case success(SEGMENT_SUMMARY):
      return state.set("segment_summary", action.payload).toJS();
    case CLEAR_SEGMENT_SUMMARY:
      return state
        .remove("segment_summary")
        .remove("segment_counts")
        .remove("rules_count")
        .toJS();
    case success(SEGMENT_COUNTS):
      return state.set("segment_counts", action.payload).toJS();
    case success(SEGMENT_ATTR_COUNTS):
      return state.set("rules_count", action.payload).toJS();
    case CLEAR_SEGMENT_ATTR_COUNTS:
      return state.remove("rules_count").toJS();
    case request(REQUEST_ACTIVATION):
      return state
        .remove("request_activation_error")
        .remove("request_activation_success")
        .toJS();
    case failure(REQUEST_ACTIVATION):
    case invalid(REQUEST_ACTIVATION):
      return state
        .set("request_activation_error", action.payload.message)
        .toJS();
    case success(REQUEST_ACTIVATION):
      return state
        .set("request_activation_success", true)
        .remove("request_activation_error")
        .toJS();
    default:
      return state.toJS();
  }
};
export default {
  segmentCreation,
  segmentDetail,
};



// WEBPACK FOOTER //
// ./src/reducers/segment.js